var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{ref:"areaSelect",staticClass:"csz",attrs:{"options":_vm.areas,"clearable":"","placeholder":_vm.placeholder,"filterable":true,"show-all-levels":true,"props":_vm.props},on:{"change":_vm.handleItemChange},model:{value:(_vm.areaCode),callback:function ($$v) {_vm.areaCode=$$v},expression:"areaCode"}})
}
var staticRenderFns = []

export { render, staticRenderFns }